import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserManagementService } from '../../service/user-management.service';
import { GroupManagementService } from '../../service/group-management.service';
import { NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-group-edit',
  templateUrl: './group-edit.component.html',
  styleUrls: ['./group-edit.component.css']
})
export class GroupEditComponent implements OnInit {
  groupData: any;
  userDetails: any = null;
  message: string = '';
  msgs: Message[] = [];

  constructor(public route: ActivatedRoute, public dataService: GroupManagementService, private userService: UserService, public router: Router) { }

  ngOnInit() {

    this.getGroup();
  }

  getGroup() {
    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;

      const GroupId = this.route.snapshot.paramMap.get('id');
      if (GroupId) {
          if (this.userDetails) { // && (this.userDetails.ClientRoleAdministration)) {
            this.dataService.getGroupDetails(GroupId).subscribe(result => {
              this.groupData = result;
            },
              (err: HttpErrorResponse) => {
                this.showMessage('error', '', 'תקלה באחזור הודעה');
              });
          }
          else {
            this.showMessage('error', '', 'Access denied');
          }


      } else {
        this.groupData = {
          GroupId: null,
          GroupName: null,
          PrivateToUserId: null,
          Active: true,
          isPrivate: this.userDetails.ClientRoleAdministration ? null : true,
          PrivateToUser: ''
        };
      }

    }, (err: HttpErrorResponse) => {
      this.userDetails = null;
      this.showMessage('error', '', 'Access denied');
    });
  }
 
  onSubmit(f: NgForm) {
    if (f.valid) {
      // this.user.Id = this.route.snapshot.paramMap.get('id');
      this.groupData.GroupName = f.value.GroupName;
      this.groupData.Active = f.value.Active;
      this.groupData.isPrivate = f.value.isPrivate;
      this.dataService.SaveGroup(this.groupData).subscribe(res => {
        this.showMessage('success', '', 'פרטי קבוצה נשמרו');
        this.router.navigate(['group-list']);

      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בשמירת פרטי קבוצה');
        });
    }
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/group-management/group-edit/group-edit.component.ts